import { FC } from 'app/FunctionalComponent'
import React from 'react'
import { FlexItem, FlexRow } from 'ui/components/layout/flexRow'
import { DisputeDetails } from 'ui/pages/provider-portal/invoice-profile/dispute-details'
import { InvoiceDetails } from 'ui/pages/provider-portal/invoice-profile/invoice-details'

export const InvoiceDisputed: FC = (props: {}) => {
	// const state = sosProviderPortal.useSubscribe()  <-- do not delete

	return (
		<React.Fragment>
			<FlexRow>
				<FlexItem>
					<InvoiceDetails />
				</FlexItem>
				<FlexItem>
					<DisputeDetails />
				</FlexItem>
			</FlexRow>
		</React.Fragment>
	)
}
